import { MutationFunctionOptions, MutationHookOptions, useMutation } from "@apollo/client";
import { useState } from "react";
import { DocumentNode } from "graphql";

/**
 * There are known bugs around loading states with @apollo/client version 3 and Hot Module Reloading in Webpack
 * We seem to be using 3.7 of @apollo/client and the last version of 3 was 3.14 which may fix this, there is also
 * a version 4, but that looks like a major change.
 *
 * So, for now, this is wrapper for the mutation to use our own loading state with the promise.
 */
export function useMutationThatWorksWithHMR(
    query: DocumentNode,
    options: MutationHookOptions
): [(options: MutationFunctionOptions) => Promise<void>, { loading: boolean; error: unknown }] {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<null | unknown>(null);
    const [mutation] = useMutation(query, options);

    return [
        async (mutationFunctionOptions: MutationFunctionOptions) => {
            try {
                setError(null);
                setIsLoading(true);
                await mutation(mutationFunctionOptions);
                setIsLoading(false);
            } catch (e) {
                setIsLoading(false);
                setError(e);
                // No need to re-throw as the error is already handled in the onError callback of the mutation options.
            }
        },
        { loading: isLoading, error: error },
    ];
}
